import Nope from 'nope-validator';

export const UserSchema = Nope.object().shape({
  userName: Nope.string().required(),
  email: Nope.string().required().email(),
  phone: Nope.string().required(),
  companyName: Nope.string().required(),
});
